<template>
  <div class="container" style="background:var(--bg3);">
    <div class="flex-wrap flex-between" style="height:40px;padding:0 10px;border-bottom:1px solid var(--border)">
      <div style="font-weight:bold;">快速访问</div>
      <div></div>
    </div>
    <div>
      <template v-for="item in data">
        <div style="padding:5px 10px;border-bottom:1px solid var(--border)"><a :href="item.url" target="_blank">{{ item.name }}</a></div>
      </template>

    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
};
</script>

<style lang="scss" scoped>

</style>
